module.exports = __webpack_public_path__ + "img/start.4c57f848.png";